import { addDays, addMonths } from 'date-fns';
import { useContext } from 'react';
import { AppContext } from '../AppContext';

export const useTaskGenerator = () => {
  const { user } = useContext(AppContext);

  return (task) => {
    // always return at least [task]
    if (!user?.uid || !task.date || !task.recurringUntil) return [task];

    const {
      id: originalId = null,
      date: isoStart,
      recurring,
      recurringUntil: isoUntil,
      ...rest
    } = task;

    const startDate = new Date(isoStart);
    const untilDate = new Date(isoUntil);
    const freq = Number(recurring.frequency) || 0;
    if (freq <= 0) return [task];

    let cur = startDate;
    const out = [];

    // choose step function
    const stepFn = recurring.period === 'month'
      ? (d) => addMonths(d, freq)
      : (d) => addDays(d, freq * (recurring.period === 'week' ? 7 : 1));

    while (cur <= untilDate) {
      out.push({
        ...rest,
        date: cur.toISOString(),
        originalRecurringTaskId: originalId,
        recurring: { ...recurring },
        recurringUntil: isoUntil,
      });
      cur = stepFn(cur);
    }

    return out;
  };
};
